import { useState } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";

import { useDisclosure } from "../../../../hooks/useDisclosure";
import { useDeleteWebUrl } from "../../../../api/webUrls";
import { paths } from "../../../../routes/paths";
import StyledModal from "../../../../Components/Modal/StyledModal";
import styleWebUrls from "./WebUrls.module.css";

export const useColumns = refetch => {
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState(null);
  const { onOpen, isOpen, onClose } = useDisclosure();
  const { mutateAsync: mutateAsyncDelete, isLoading: isLoadingDelete } =
    useDeleteWebUrl();

  const handleDelete = id => {
    onOpen();
    setDeleteId(id);
  };

  const handleDeleteWebUrl = () => {
    mutateAsyncDelete(deleteId)
      .then(res => {
        if (res?.data) {
          toast.success(res?.data?.message);
          onClose();
          refetch();
        }
      })
      .catch(err => {
        toast.error(
          err?.response?.data?.error ||
            err?.response?.data?.message ||
            err?.message
        );
        onClose();
      });
  };

  const columns = [
    {
      title: "S.N",
      render: ({ sn }) => {
        return <div>{sn}</div>;
      },
    },
    {
      title: "Name",
      render: ({ name }) => {
        return <div>{name}</div>;
      },
    },
    {
      title: "URL",
      render: ({ id, url }) => {
        return (
          // <Link
          //   to={paths.admin.webUrls.view(id)}
          //   className="text-blue-500 hover:underline"
          // >
          <div>
            {url}
            </div>
          // </Link>
        );
      },
    },
    {
      title: "View",
      render: row => {
        return (
          <div>
            <button
              className="bg-[#299aff] px-4 py-2 rounded text-white"
              onClick={() =>
                navigate(paths.admin.webUrls.view(row?.id), {
                  state: { item: row },
                })
              }
            >
              View
            </button>
          </div>
        );
      },
    },
    {
      title: "Action",
      render: row => {
        return (
          <div>
            <button
              onClick={() =>
                navigate(`/web-twinprocms/web-urls/${row?.id}/update`, {
                  state: { item: row },
                })
              }
              className={styleWebUrls["modify-scene-btn"]}
            >
              <FontAwesomeIcon icon={faPen} />
            </button>{" "}
            <button
              className={styleWebUrls["delete-scene-btn"]}
              onClick={() => handleDelete(row?.id)}
            >
              <FontAwesomeIcon icon={faTrashCan} />
            </button>
            <StyledModal
              isOpen={isOpen}
              onClose={onClose}
              onConfirm={handleDeleteWebUrl}
              loading={isLoadingDelete}
            />
          </div>
        );
      },
    },
  ];
  return { columns };
};